import {
  withTranslation,
} from 'react-i18next';

import RegattaPaymentDiscountFieldsView from './RegattaPaymentDiscountFieldsView';

const TranslatedComponent = withTranslation()(RegattaPaymentDiscountFieldsView);

const Component = TranslatedComponent;

export default Component;
